import React from 'react';
import ReactDom from 'react-dom'; //needed to hook into element that renders app

import App from './App';

ReactDom.render(<App/>, document.getElementById('root'));